import React from "react";
import { MaskedReveal, FadeUp } from "@/components/motion/Reveal";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    intro: "Helkar & Associates respects the privacy of every visitor and client. This policy explains what personal data we collect, how it is used and the rights available to you.",
    sections: [
      { h: "Information we collect", p: "We collect information you provide voluntarily through consultation forms and correspondence — name, contact details and matter description. We also collect standard log data such as browser type and pages visited." },
      { h: "Use of information", p: "Information is used solely to respond to enquiries, provide legal services and comply with statutory obligations. We do not sell or lease personal data." },
      { h: "Confidentiality", p: "Attorney–client privilege applies to information shared during and after formal engagement. Our systems and staff are governed by strict confidentiality protocols." },
      { h: "Cookies", p: "Our website uses cookies only for essential functionality and anonymised analytics. You may disable cookies in your browser settings." },
      { h: "Your rights", p: "You may request access to or deletion of your personal data by writing to helkarandassociates@gmail.com." },
    ],
  },
  terms: {
    title: "Terms of Use",
    intro: "By accessing this website you agree to the following terms. If you do not agree, please refrain from using the site.",
    sections: [
      { h: "No solicitation", p: "This website is not an advertisement or solicitation. It provides general information about Helkar & Associates and its practice areas." },
      { h: "No legal advice", p: "Content on this site is not legal advice and should not be relied upon as such. Legal advice can only be provided after formal engagement." },
      { h: "Intellectual property", p: "All content, marks and design elements are the property of Helkar & Associates unless otherwise noted." },
      { h: "Third-party links", p: "Where the website links to external resources, Helkar & Associates is not responsible for the content or practices of those third parties." },
    ],
  },
  disclaimer: {
    title: "Legal Disclaimer",
    intro: "As per the rules of the Bar Council of India, advocates are not permitted to solicit work or advertise. The information provided on this website is for general purposes only.",
    sections: [
      { h: "Acknowledgement", p: "By continuing to use this website, the visitor acknowledges that they have accessed the site of their own accord, that no solicitation has been made by Helkar & Associates and that information is used at their own risk." },
      { h: "No attorney–client relationship", p: "Nothing on this website — including submission of a consultation form — creates an attorney–client relationship. Engagement is confirmed only through a written engagement letter." },
      { h: "Content accuracy", p: "While we make reasonable efforts to keep information current, laws change frequently. Please consult a qualified advocate for advice on your specific matter." },
    ],
  },
};

export default function Legal({ kind }) {
  const data = CONTENT[kind] || CONTENT.privacy;
  return (
    <div data-testid={`legal-${kind}`}>
      <section className="pt-40 pb-16">
        <div className="mx-auto max-w-[900px] px-6 md:px-10">
          <div className="mono text-xs uppercase tracking-[0.32em] text-gold mb-6">Legal · {data.title}</div>
          <MaskedReveal as="h1" className="serif text-5xl md:text-7xl leading-[0.98]" lines={[data.title]} />
          <FadeUp delay={0.3} className="mt-8 text-[hsl(var(--muted-foreground))] text-lg leading-relaxed">{data.intro}</FadeUp>
        </div>
      </section>
      <section className="pb-32">
        <div className="mx-auto max-w-[900px] px-6 md:px-10 space-y-10">
          {data.sections.map((s, i) => (
            <FadeUp key={i} delay={i * 0.06} className="border-t hairline pt-6">
              <div className="chapter-num text-2xl">{String(i + 1).padStart(2, "0")}</div>
              <h2 className="serif text-2xl md:text-3xl mt-2 mb-3">{s.h}</h2>
              <p className="text-[17px] leading-[1.85] text-[hsl(var(--muted-foreground))]">{s.p}</p>
            </FadeUp>
          ))}
        </div>
      </section>
    </div>
  );
}
